import { MainScreen } from './main';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import { AnimatePresence } from 'framer-motion';

function App() {
  return (
    <AnimatePresence>
      <Router>
        <Routes>
          {/* One layout route so MainScreen (and its websocket) stays mounted across / and /info */}
          <Route element={<MainScreen />}>
            <Route path='/' />
            <Route path='/info' />
          </Route>
        </Routes>
      </Router>
    </AnimatePresence>
  );
}

export default App;
